import { render, staticRenderFns } from "./SharedProgramTitle.vue?vue&type=template&id=ae4205bc&scoped=true&"
import script from "./SharedProgramTitle.vue?vue&type=script&lang=js&"
export * from "./SharedProgramTitle.vue?vue&type=script&lang=js&"
import style0 from "./SharedProgramTitle.vue?vue&type=style&index=0&id=ae4205bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4205bc",
  null
  
)

export default component.exports